import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { Auth, API } from "aws-amplify";
import { onError } from "../libs/errorLib";
import { formatDateG, formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import AdminLeftMenu from "./AdminLeftMenu";
import AdminMailConfirm from "./AdminMailConfirm";
import MemberTypeItemNames from "./MemberTypeItemNames";
import "./Admin.css";
import "../admin.css";

export default function AdminMailHistories() {
  const search = useLocation().search;
  const qPage = new URLSearchParams(search).get('page'); // page
  console.log('qPage = ' + qPage);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1);

  const [renderingState, setRenderingState] = useState('Main');

  const [his, setHis] = useState([]);
  const history = useHistory();

  const [mailTos, setMailTos] = useState([]);
  const [dests, setDests] = useState([]);
  const [hisElement, setHisElement] = useState({});

  const [refreshCounter, setRefreshCounter] = useState(0);
  const [checks, setChecks] = useState([]);
  const [selectAll, setSelectAll] = useState(0);

  const today = new Date();
  today.setMonth(today.getMonth() - 1);
  const [sYearOfFee, setSYearOfFee] = useState(today.getFullYear());

  const [kwSubject, setKwSubject] = useState("");
  const [kwMailBody, setKwMailBody] = useState("");

  let year = new URLSearchParams(search).get('y');
  if (!year) year = "2020";

  const [pageLimit, setPageLimit] = useState("10");

  useEffect(() => {
    console.log('useEffect called...');
    const onLoad = async () => {
      try {
        console.log('onLoad called...');
        const anonymousUser = await Auth.currentCredentials();
        //console.log(anonymousUser);
        const hs = await loadHistories(); 
        console.log(hs);
        setHis(hs);
      } catch (e) {
        onError(e);
      }
    };
    onLoad();
  },[refreshCounter]);

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    sYBegin: today.getFullYear(),
    sMBegin: today.getMonth() + 1,
    sDBegin: today.getDate(),
    sYEnd: "0000",
    sMEnd: "00",
    sDEnd: "00",
    mAffiliationName: "",
    orderBy: "1",
    ascOrDesc: "1",
    updateStatus: "0",
  },
  {
    sYBegin: {n:"", f: (value) => { return '' }},
    sMBegin: {n:"", f: (value) => { return '' }},
    sDBegin: {n:"", f: (value) => { return '' }},
    sYEnd: {n:"", f: (value) => { return '' }},
    sMEnd: {n:"", f: (value) => { return '' }},
    sDEnd: {n:"", f: (value) => { return '' }},
    mAffiliationName: {n:"", f: (value) => { return '' }},
    orderBy: {n:"", f: (value) => {  return '' }},
    ascOrDesc: {n:"", f: (value) => { return '' }},
    updateStatus: {n:"", f: (value) => { return '' }},
  });

  function loadHistories() {
    console.log('loadhistories...');
    console.log(fields.sMBegin);
    console.log(fields.sDBegin);
    console.log(today);
    let p = "";
    if (kwSubject)
      p += `sj=${kwSubject}`;
    if (kwMailBody)
      p += (p.length > 0 ? '&' : '' ) + `mb=${kwMailBody}`;

    if (fields.sYBegin != '0000') {
      const m = fields.sMBegin == '00' ? '01' : fields.sMBegin;
      const d = fields.sDBegin == '00' ? '01' : fields.sDBegin;
      fields.sMBegin = m;
      fields.sDBegin = d;
      p += (p.length > 0 ? '&' : '' ) + `ds=${fields.sYBegin}-${m}-${d}`;
    }
    if (fields.sYEnd != '0000') {
      const m = fields.sMEnd == '00' ? '01' : fields.sMEnd;
      const d = fields.sDEnd == '00' ? '01' : fields.sDEnd;
      p += (p.length > 0 ? '&' : '' ) + `de=${fields.sYEnd}-${m}-${d}`;
    }
    const path = `/mailHistories` + (p.length > 0 ? '?' + p : '');
    console.log(path);
    const hs = API.get("sakurajima", path);
    return hs;
  }

  const { userProfile } = useAppContext();


  // mAnnualFees checkbox
  const [mAnnualFees, setMAnnualFees] = useState([0,0]);

  async function handleSearch(event) {
    console.log('handleSearch...');
    try {
      const hs = await loadHistories(); 
      setHis(hs);
    } catch (e) {
      onError(e);
    }
  }

  function handleView(e, i) {
    console.log('i = ' + i);
    console.log(his[i].dests);
    setHisElement(his[i]);
    setDests(his[i].dests);
    let a = []; for(let j=0; j < his[i].dests.length; j++) a.push(j);
    setMailTos(a);
    setRenderingState('ViewMail');
  }

  function handleEdit(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/editMembers/${pk}`);
  }

  function handleMAnnualFeesChange(event) {
    console.log('handleMAnnualFeesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mAnnualFees'.length));
    let chs = JSON.parse(JSON.stringify(mAnnualFees));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMAnnualFees(chs);
  }
  const setDefaultDateInterval = () => {
  };

  function handleClear(evenat) {
    console.log('handleClear...');
//    setMStatus([0,0,0,0,0]);
    fields.sYBegin = '0000';
    fields.sMBegin = '00';
    fields.sDBegin = '00';
    fields.sYEnd = '0000';
    fields.sMEnd = '00';
    fields.sDEnd = '00';
    fields.mNumEnd = '';
    fields.mAffiliationName = "";
    setMAnnualFees([0,0]);

    setSYearOfFee(today.getFullYear());
    fields.orderBy = "1";
    fields.ascOrDesc = "1";
    setPageLimit("10");
//    setRefreshCounter(refreshCounter+1);
  }

  const getStatusName = (state) => {
      if (1 == state)
	  return '入金済';
      else
	  return '未入金';
  };

  const getMemberId = (data) => {
//    const d = data.split('#');
//    return d[1];
      return data.memberId;
  };

  const handleItemCheckChanged = (e) => {
    console.log('handleItemCheckChanged...');
    let chs = JSON.parse(JSON.stringify(checks));
    console.log(chs);
    if ('selectAll' === e.target.name) {
      for(let i=0; checks.length > i; i++) {
        chs[i] = e.target.checked ? 1 : 0;
        setChecks(chs);
      }
      setSelectAll(e.target.checked ? 1 : 0);
      return;
    }
    console.log(e.target.value);
    setSelectAll(0);
    chs[e.target.value] = e.target.checked ? 1 : 0;
    setChecks(chs);
  };

  const pageClickAction = (e) => {
    e.preventDefault();
    console.log('pageClick');
    console.log(e.target.href.split('#'));
    setCurrentPage(e.target.href.split('#')[1]);
    return false;
  };

    const getToLength = (to) => {
        console.log(to);
                
	return to ? to.length : 0;
    }

  function backFromMail(event) {
    console.log('handleMail');
    console.log(event.target.id);
    setRenderingState('Main');
  }

  function renderViewHistory() {
    console.log('renderViewHistory...');
    console.log(dests);
    return (
      <AdminMailConfirm
        his={hisElement}
        members={dests}
        backFromMail={backFromMail}
        mailTos={mailTos}
      />
    );
  }

  function renderMain() {
    return (
              <section id="contents" className="top">
                <h2>メール送信履歴</h2>
                <div id="search">
                  <h3>条件検索</h3>
                  <Table>
                    <tbody>
                      <tr>
                        <th>タイトル</th>
                        <td>
                          <Form.Group controlId="sSubject" size="sm">
                            <Form.Control
                              type="text"
                              value={kwSubject}
                              onChange={ (e) => setKwSubject(e.target.value) }
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>キーワード</th>
                        <td>
                          <Form.Group controlId="mAffiliationName" size="sm">
                            <Form.Control
                              type="text"
                              value={kwMailBody}
                              onChange={ (e) => setKwMailBody(e.target.value) }
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>配信日</th>
                        <td>
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sYBegin" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sYBegin"
                              value={fields.sYBegin}
                              onChange={handleFieldChange}
                            >
                              <option value="0000"></option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                            </Form.Control>
                          </Form.Group> 年
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sMBegin" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sMBegin"
                              value={fields.sMBegin}
                              onChange={handleFieldChange}
                            >
                              <option value="00"></option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </Form.Control>
                          </Form.Group> 月
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="sDBegin" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sDBegin"
                              value={fields.sDBegin}
                              onChange={handleFieldChange}
                            >
                              <option value="00"></option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>
                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                              <option value="23">23</option>
                              <option value="24">24</option>
                              <option value="25">25</option>
                              <option value="26">26</option>
                              <option value="27">27</option>
                              <option value="28">28</option>
                              <option value="29">29</option>
                              <option value="30">30</option>
                              <option value="31">31</option>
                            </Form.Control>
                          </Form.Group> 日 〜　
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sYEnd" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sYEnd"
                              value={fields.sYEnd}
                              onChange={handleFieldChange}
                            >
                              <option value="0000"></option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                            </Form.Control>
                          </Form.Group> 年
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sMEnd" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sMEnd"
                              value={fields.sMEnd}
                              onChange={handleFieldChange}
                            >
                              <option value="00"></option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </Form.Control>
                          </Form.Group> 月
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="sDEnd" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sDEnd"
                              value={fields.sDEnd}
                              onChange={handleFieldChange}
                            >
                              <option value="00"></option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>
                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                              <option value="23">23</option>
                              <option value="24">24</option>
                              <option value="25">25</option>
                              <option value="26">26</option>
                              <option value="27">27</option>
                              <option value="28">28</option>
                              <option value="29">29</option>
                              <option value="30">30</option>
                              <option value="31">31</option>
                            </Form.Control>
                          </Form.Group> 日
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="search_btn">
                    <Button id="searchBtn" active size="sm" active onClick={ handleSearch }>検索</Button>
                    <Button id="resetBtn" active size="sm" active onClick={ handleClear }>検索条件クリア</Button>
                 </div>
                </div>
               <div id="list">
                 <p>配信件数： <b>{ his.length }</b>件</p>
                 <Table>
                   <tbody>
                     <tr>
                       <th>タイトル</th>
                       <th>配信日時</th>
                       <th>配信件数</th>
                       <th>送信件数</th>
                       <th>処理</th>
                     </tr>
                     <tr>
                     </tr>
          {his.map(({pk,sk,data, createdAt, to}, index) => (
                     <tr>
                       <td>
                  { data  }
                       </td>
                       <td>
                  { formatDateG(new Date(createdAt), 'yyyy/MM/dd HH:mm') }
                       </td>
                       <td>
                  { getToLength(to) } 件
                       </td>
                       <td>
                  { getToLength(to) } 件
                       </td>
                       <td>
                  <Button id="editfBtn" pk={ pk } keyIndex={ index }  active size="sm" active onClick={ (e) => handleView(e, index) }>詳細</Button>
                       </td>
                  </tr>
                     ))}
                   </tbody>
                 </Table>
                 <div className="pageswitch">
                    <ul>
          { pages.map(({label}, index) => (
		  <li className={(currentPage == index+1) ? 'active' : ''}><Nav.Link href={ "#" + (index+1)} onClick={pageClickAction}>{index+1}</Nav.Link></li>
	  ))}
                    </ul>
                  </div>
               </div>
              </section>
    );
  }

  return (
    <div className="Admin">
      <h1 id="page_title">管理者用　メール送信履歴</h1>
      <div className="container">
        <div id="sub_page">
          <div id="admin" className="top">
              <AdminLeftMenu />
	  { renderingState == 'Main' ? renderMain() : renderViewHistory() }
          </div>
        </div>
      </div>
    </div>
  );
}
